export const PRODUCT_FILTERS_INIT = 'PRODUCT_FILTERS_INIT';
export const PRODUCT_FILTERS_SEARCH = 'PRODUCT_FILTERS_SEARCH';
export const PRODUCT_FILTERS_SET_FILTERS = 'PRODUCT_FILTERS_SET_FILTERS';
export const PRODUCT_FILTERS_ORDER = 'PRODUCT_FILTERS_ORDER';
export const PRODUCT_FILTERS_ORDER_FIELD = 'PRODUCT_FILTERS_ORDER_FIELD';
